import 'select2';
import 'select2/dist/js/i18n/ru';
import $ from 'jquery';

/**
 * @callback GetOptions
 * @param {object} vm
 * @returns {import('select2').Options}
 */

/**
 *
 * @param {import('select2').Options|GetOptions} options
 * @returns
 */
export function withSelect2(options) {
	let getOptions = typeof options !== 'function' ? () => options : options;

	/** @type {import('select2').Select2 & { $element: JQuery<HTMLSelectElement>}} */
	let instance;

	return {
		props: ['value', 'placeholder'],
		mounted() {
			const vm = this;
			const emitSelect = (event) => this.$emit('select', event.params.data);

			const $select = $(this.$refs.select)
				.select2({
					...getOptions(vm),
					placeholder: vm.placeholder,
					debug: true,
				})
				.on('select2:select', emitSelect);

			this.$options.select2 = instance = $select.data('select2');
		},
		destroyed() {
			instance.$element.select2('destroy')
		},
		watch: {
			value: function(newVal) {
				instance.$element
					.val(newVal)
					// `JQuery.trigger` doesn't trigger native events
					.each((idx, element) => element.dispatchEvent(new Event('change')));
			},
		},
	}
}
